import { productCodeToNameMappings } from "pages/geoscape-data/constants";
import { toTitleCase } from "utils/commons";

export function formatProductName(productNameRaw: string, applyMapping: boolean = true): string {
  if (applyMapping) {
    const lookup = productCodeToNameMappings.get(productNameRaw);
    if (lookup) {
      return lookup;
    }
  }

  return toTitleCase(productNameRaw);
}

/**
 * Label for a product definition from the datasets API. A Hub-side mapping wins where one
 * exists — that is how display-only renames like "ABS Boundaries (Legacy)" take effect
 * without touching the API — otherwise the API's own display name is used, so products
 * absent from `productCodeToNameMappings` keep their rebranded names.
 */
export function formatProductDefinitionName(
  productCode: string,
  apiDisplayName: string,
): string {
  return (
    productCodeToNameMappings.get(productCode) ?? toTitleCase(apiDisplayName)
  );
}
